/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BankAccountViewModel } from './BankAccountViewModel';
import {
    BankAccountViewModelFromJSON,
    BankAccountViewModelFromJSONTyped,
    BankAccountViewModelToJSON,
} from './BankAccountViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfBankAccountViewModel
 */
export interface ResultOfBankAccountViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfBankAccountViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBankAccountViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBankAccountViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBankAccountViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBankAccountViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfBankAccountViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfBankAccountViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {BankAccountViewModel}
     * @memberof ResultOfBankAccountViewModel
     */
    data?: BankAccountViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBankAccountViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfBankAccountViewModel interface.
 */
export function instanceOfResultOfBankAccountViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfBankAccountViewModelFromJSON(json: any): ResultOfBankAccountViewModel {
    return ResultOfBankAccountViewModelFromJSONTyped(json, false);
}

export function ResultOfBankAccountViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfBankAccountViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : BankAccountViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfBankAccountViewModelToJSON(value?: ResultOfBankAccountViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': BankAccountViewModelToJSON(value.data),
        'Count': value.count,
    };
}

